export const overlayInnerStyle = {
  backgroundColor: 'white',
  border: 'none',
  fontSize: 14,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0px 4px',
  color: '#344054',
  borderRadius: 4,
};
export const overlayStyle = {
  // backgroundColor: 'white',
  fontSize: 14,
  // boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.1)',
  color: '#344054',
  borderRadius: 4,
  width: 'max-content',
};
export const rcTooltipClass = {
  tooltipOverlayClass: 'tooltipOverlayClass',
};
